import React from 'react';
import { connect } from "react-redux";
import {Card, Container, Form, Input, Message} from "semantic-ui-react";
import {setDPFormValues, updateContactInfo} from "../actions/AddEditDPActions";
import * as Validation from "../../../common/utils/Validation";


export class DataProviderForm extends React.Component {

    handleInputChange = (e, { name, value, change_obj }) => {
        e.preventDefault();
        this.props.setDPForm({ name, value, change_obj });
    };

    handleContactInfoChange = (e, { name, value, change_obj }) => {
        e.preventDefault();
        this.props.setContactInformation({ name, value, change_obj });
    };

    handleDismiss = () => {
        Validation.clearMessages();
    }

    render() {

        const {
            providerObject,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification
        } = this.props;

        return (
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        required
                                        control={Input}
                                        type="text"
                                        label="Provider Name"
                                        placeholder="Provider Name"
                                        value={providerObject.provider_detail.provider_name}
                                        name="provider_name"
                                        change_obj="provider_detail"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        type="text"
                                        label="Monthly Volume Requirements (Provider Level)"
                                        placeholder="ex. 10000"
                                        value={providerObject.provider_detail.monthly_aggregate_volume === null
                                            ? ""
                                            : providerObject.provider_detail.monthly_aggregate_volume}
                                        name="monthly_aggregate_volume"
                                        change_obj="provider_detail"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                                {providerObject.contact_information.length === 0 ? null
                                    : (
                                        providerObject.contact_information.map((info, idx) => {
                                            return(
                                                <Form.Group widths="equal" key={idx}>
                                                    <Form.Input
                                                        type="text"
                                                        label={info.type + " Contact Name"}
                                                        placeholder={info.type + " Contact Name"}
                                                        value={info.name === null ? "" : info.name}
                                                        name={info.type === null ? "" : info.type}
                                                        change_obj="name"
                                                        onChange={this.handleContactInfoChange}
                                                    />
                                                    <Form.Input
                                                        type="text"
                                                        label={info.type + " Contact Email"}
                                                        placeholder="john@email.com"
                                                        value={info.email === null ? "" : info.email}
                                                        name={info.type}
                                                        change_obj="email"
                                                        onChange={this.handleContactInfoChange}
                                                    />
                                                    <Form.Input
                                                        type="text"
                                                        label={info.type + " Contact Phone"}
                                                        placeholder="8005551234"
                                                        value={info.phone_number}
                                                        name={info.type}
                                                        change_obj="phone_number"
                                                        onChange={this.handleContactInfoChange}
                                                    />
                                                </Form.Group>
                                            )}))
                                }

                            </Card.Content>
                        </Card>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    providerObject: state.veritas.addEdit.addEditDP.providerObject,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    setDPForm: ({ name, value, change_obj }) => {
        dispatch(setDPFormValues({ name, value, change_obj }))
    },
    setContactInformation: ({ name, value, change_obj }) => {dispatch(updateContactInfo({ name, value, change_obj }))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProviderForm);
